export function getNextListboxOptionIndex(currentIndex: number, optionCount: number, direction: 1 | -1): number {
  if (optionCount <= 0) {
    return -1;
  }

  if (currentIndex < 0 || currentIndex >= optionCount) {
    return direction === 1 ? 0 : optionCount - 1;
  }

  return (currentIndex + direction + optionCount) % optionCount;
}
